import React from "react";
import OngoingConnections from "../../../../Components/Bilateral/LedgerPageDashboardActive/OngoingConnections";

const Ongoing = () => {
  return (
    <>
      <OngoingConnections />
    </>
  );
};

export default Ongoing;
